import React, { useContext, useEffect } from 'react';
import { FormContext } from '../../../store/MLI/MLIContext';
import { Button } from '../../shared/Button';
import { getDefaultValues, formItems } from '../MLIStepper/form-items';

export const MLICalucation = () => {
    const { form, data } = useContext(FormContext);

    function generateBannerLink() {
        const path = window.location.pathname;

        let url = '';

        if (path.includes('huispediamlidesktop')) {
            url = 'Bannerlink_MLI_KIDHB&utm_campaign=70107000000PgCCAA0';
        } else if (path.includes('huispediamlimobile')) {
            url = 'Bannerlink_MLI_KIDHB_Mweb&utm_campaign=70107000000PgCCAA0';
        }

        if (path.includes('fundamliapp')) {
            url = 'Bannerlink_MLI_App_KIDHB&utm_campaign=7011v000000KF1pAAG';
        } else if (path.includes('fundamlimobile')) {
            url = 'Bannerlink_MLI_Mweb_KIDHB&utm_campaign=7011v000000KF1kAAG';
        }

        if (path.includes('goudadesktop')) {
            url = 'desktop';
        } else if (path.includes('goudamobile')) {
            url = 'mobile';
        }

        if (path.includes('huislijnmlidesktop')) {
            url = 'utm_source=huislijn&utm_medium=Webvertising&utm_content=Bannerlink_MLI_KIDHB&utm_campaign=MCMPCA1C5B284A6B09856FF10AE1DD3954';
        } else if (path.includes('huislijnmlimobile')) {
            url = 'utm_source=huislijn&utm_medium=Webvertising&utm_content=Bannerlink_MLI_Mweb_KIDHB&utm_campaign=MCMPCA1C5B284A6B09856FF10AE1DD3954';
        }

        if (path.includes('jaapmlidesktop')) {
            url = 'utm_source=jaap&utm_medium=webvertising&utm_content=Bannerlink_MLI_KIDHB&utm_campaign=70107000000Pg3IAAS';
        } else if (path.includes('jaapmlimobile')) {
            url = 'utm_source=jaap&utm_medium=webvertising&utm_content=Bannerlink_MLI_KIDHB_Mweb&utm_campaign=70107000000Pg3DAAS';
        }

				if (path.includes('huizenzoekermlidesktop')) {
					url = '/?utm_source=huizenzoeker&utm_medium=webvertising&utm_content=Bannerlink_MLI_KIDHB&utm_campaign=701070000016sgBAAQ'
				} else if (path.includes('huizenzoekermlimobile')) {
					url = '/?utm_source=huizenzoeker&utm_medium=webvertising&utm_content=Bannerlink_MLI_KIDHB_Mweb&utm_campaign=701070000016sg6AAA';
				}


        if (path.includes('mhzpmlidesktop')) {
            url = 'Bannerlink_MLI_KIDHB&utm_campaign=70107000000PpxDAAS';
        } else if (path.includes('mhzmlimobile')) {
            url = 'Bannerlink_MLI_KIDHB_Mweb&utm_campaign=70107000000Ppx8AAC';
        }

        return url;
    }

		function scrollToTop() {
			window.scrollTo(0, 0);
		}

		useEffect((() => {
			setTimeout(() => {
			const calculation = document.querySelector<HTMLDivElement>('.c-mli-calculation');
				if (calculation) {
					window.scrollTo({
						top: calculation.offsetTop,
						behavior: 'smooth',
					});
				}
			}, 1000)
		}),[data])

    function generateUrl() {
        const values = getDefaultValues(form);
        const bannerLink = generateBannerLink();

        return `https://www.hypotheker.nl/zelf-berekenen/kan-ik-dit-huis-betalen/calculator/?Onderpand_Koopsom=${
            values[formItems.mortageAmount]
        }&Klant_Jaarinkomen=${values[formItems.applicantYearlyIncome]}&Klant_Leeftijd=${
            values[formItems.applicantAge]
        }&Onderpand_Postcode=${values.postcode}&Onderpand_Huisnummer=${
            values.huisnummer
        }&Onderpand_HuisnummerToevoeging=${values.huisnummerToevoeging}&HeeftPartner=${
            values[formItems.hasPartnerIncome]
        }&Partner_Jaarinkomen=${values[formItems.partnerYearlyIncome]}&Partner_Leeftijd=${
            values[formItems.partnerAge]
        }&Onderpand_IsNieuwbouw=${values.isNieuwBouw}&EigenMiddelen=${values[formItems.ownMoney]}
        &${bannerLink}`;
    }

    return (
        <div className="c-mli-calculation">
            <div className="mli-calculation__header">
                <span className="mli-calculation__heading">
                    Netto maandlasten
                    <span className="mli-calculation__heading-price">
                        € {data && data.netMonthlyCost}
                    </span>
                </span>
                <span className="mli-calculation__heading">
                    Bruto maandlasten
                    <span className="mli-calculation__heading-price">
                        € {data && data.grossMonthlyCost}
                    </span>
                </span>
            </div>

            <div className="u-margin-top--md u-margin-bottom--md">
                <hr />
            </div>

            <div className="u-margin-bottom--sm">
                <a href={generateUrl()} target="_blank" rel="noopener noreferrer">
                    Kan ik dit huis betalen?
                </a>
            </div>
            <p className="mli-calculation__text">
                Als onafhankelijk adviseur vinden we ook voor jou de beste, voordeligste financiële
                oplossing. En we regelen alles. Het eerste gesprek is voor onze kosten en voor jou
                dus geheel kosteloos.
            </p>
            <div className="u-margin-bottom--sm">
              <Button onClick={scrollToTop} label="Afspraak maken" url="/afspraak" variant="tertiary" />
            </div>
        </div>
    );
};
